<template>
    <div class="bootstrap" >
        <h3>Список позиций с сайта pride.ru</h3>

        <div class="spacer"></div>
        <p>Данный список является коммерческим предложением компании Прайд на дату: {{ currentDate }}</p>
        <div class="spacer"></div>

        <table class="table">
            <thead>
                <tr class="thead-light">
                    <th style="width: 45%!important;">Название</th>
                    <th  class="text-center">Бренд</th>
                    <th  class="text-right">Цена</th>
                    <th  class="text-right">Вес / Объем (ед.)</th>
                    <th  class="text-center"><nobr>Кол-во</nobr></th>
                    <th  class="text-right">Стоимость</th>
                </tr>

            </thead>
            <tbody>
                <tr v-for="item in basketItems" :key="item.id">
                    <td><span >{{ item.name }}</span> <br />
                        <span class="text-muted">Код: {{ item.code }}</span>, &nbsp;
                        <span class="text-muted">Артикул: {{ item.articul }} </span>
                    </td>
                    <td class="text-center"><span class="text-muted"> {{ item.brand_name }} </span></td>
                    <td class="text-right"><nobr> {{ item.current_price.amount  | priceFormat }} ₽</nobr></td>
                    <td class="text-right"><span > {{ item.weight }} </span> кг. <br />
                        <small class="text-muted"> {{ item.volume }} </small> м<sup>3</sup> <br />
                        <!-- {{ item.length }} x {{ item.width }} x {{ item.height }} мм -->
                    </td>
                    <td class="text-center">
                        <nobr>{{ item.count }} шт.</nobr>
                    </td>
                    <td class="text-right"><nobr><span>{{ item.current_price.amount * item.count  | priceFormat }}</span> ₽</nobr></td>
                </tr>
            </tbody>
            <thead>
            <tr style="border-top: 2px solid black;">
                <th colspan="3">ИТОГО:</th>
                <th class="text-right"><span>{{ totalWeight }}</span> кг. <br />
                    <small class="text-muted"> {{ totalVolume }} м<sup>3</sup></small></th>
                <th class="text-right"><span>{{ totalCount }}</span> шт.</th>
                <th class="text-right"><span>{{ total | priceFormat  }}</span> ₽</th>
            </tr>
            </thead>

        </table>
    </div>
</template>

<script>
    export default {
        name: "BasketPrint",
        computed: {
            currentDate() {
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                return dd + '.' + mm + '.' + yyyy;
            },
            basketItems () {
                return this.$store.state.basket;
            },
            total () {
                return this.$store.getters.basketTotal
            },
            totalCount () {
                return this.$store.getters.basketTotalCount
            },
            totalWeight () {
                return this.$store.getters.basketTotalWeight.toFixed(2)
            },
            totalVolume () {
                return this.$store.getters.basketTotalVolume.toFixed(6)
            },
        },
        created() {
            window.print()
        }
    }
</script>

<style scoped>
    .bootstrap {
        margin: 20px;
    }

    @media print {
        .bootstrap {
            font-size: 70%;
        }
    }
</style>